import { PropsWithChildren, useRef } from "react";
import PageSelector from "./PageSelector";

const PaginationLayout = ({
  page,
  count,
  totalItems,
  children,
  className,
  setPage
}: PropsWithChildren<{
  page: number;
  count: number;
  totalItems: number;
  className?: string;
  setPage: (page: number) => void;
}>) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <main
      ref={ref}
      className={
        "flex flex-grow flex-col items-center justify-between " + className
      }
    >
      <section className="grid w-full auto-rows-fr grid-cols-1 gap-6 px-6 pt-4 sm:grid-cols-2 md:grid-cols-3">
        {children}
      </section>

      <div className="flex w-full flex-col items-center">
        {totalItems > 0 && (
          <PageSelector
            className="mb-7 mt-7"
            page={page}
            count={count}
            totalItems={totalItems}
            setPage={page => {
              setPage(page);

              if (ref.current) ref.current.scroll(0, 0);
            }}
          />
        )}

        {/* Footer removed for admin users page */}
      </div>
    </main>
  );
};

export default PaginationLayout;